import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classes from './TimesCircle.module.css';

const TimesCircle = ({ onClick, className }) => {
  return (
    <FontAwesomeIcon
      icon={['fas', 'times-circle']}
      className={`${classes.icon} ${className}`}
      onClick={onClick}
      title="Delete"
    />
  );
};

export default TimesCircle;
